import { atom } from 'recoil';

export const isPreliminaryQuestionSavedAtom = atom<boolean>({
    key: 'isPreliminaryQuestionSaved',
    default: false
});
